import {AccessRights} from "../schemas/accessRightsModel";
import {AVAILABLE_VISUALIZERS} from "../constants/dashboard";

const checkSubscription = (roomName, state) => {
  const AR = AccessRights.get(state);
  if (AR.isSiteAdmin()) {
    return true
  }
  const {auth, asCustomer} = state;
  if (asCustomer.data) {
    if (!asCustomer.data.subscriptions || !asCustomer.data.subscriptions[roomName]) {
      return false
    }
    return asCustomer.data.subscriptions[roomName].id > 0
  }
  if (auth.subscriptions && auth.subscriptions[roomName]) {
    return auth.subscriptions[roomName].id > 0
  }
  return false
}

export const hasSubscriptions = (state) =>{

  const hasKitchen = checkSubscription('kitchen', state);
  const hasBathroom = checkSubscription('bathroom', state);
  const hasFireplace = checkSubscription('fireplace', state);
  const hasLaundryRoom = checkSubscription('laundryroom', state);

  // console.log("hasKitchen", hasKitchen);
  // console.log("hasBathroom", hasBathroom);

  let allSubscriptions = [];
  if (hasKitchen) {
    allSubscriptions.push(AVAILABLE_VISUALIZERS.kitchen);
  }
  if (hasBathroom) {
    allSubscriptions.push(AVAILABLE_VISUALIZERS.bathroom);
  }
  if (hasFireplace) {
    allSubscriptions.push(AVAILABLE_VISUALIZERS.fireplace);
  }
  if (hasLaundryRoom) {
    allSubscriptions.push(AVAILABLE_VISUALIZERS.laundryroom);
  }

  return {hasKitchen, hasBathroom, hasFireplace, hasLaundryRoom, allSubscriptions}
}
